module.exports = __webpack_public_path__ + "static/media/dark_icn_map_fermata_scambio.00d30989.svg";